import { createSlice } from "@reduxjs/toolkit";
import { getCollectionData } from "./collection-images-actions";

const collectionImagesSlice = createSlice({
    name:"collectionImages",
    initialState:{
        loading:true,
        collectionName: "",
        collectionImages: [],
        error:""
    },
    reducers: {},
    extraReducers:{
        [getCollectionData.fulfilled]: (state,action) => {
            state.loading = false;
            state.collectionName = action.payload.collectionName;
            state.collectionImages = action.payload.collectionImages;
            state.error = "success";
        },
        [getCollectionData.rejected]: (state,action) => {
            state.loading = false;
            state.error = action.payload;
        }
    }
})

export const collectionActions = collectionImagesSlice.actions;
export default collectionImagesSlice;